import { gql } from "@apollo/client";

export const GET_ALL_USERS = gql`
  query users($pagination: PaginationInput!) {
    users(pagination: $pagination) {
      pagination {
        page
        limit
        total
      }
      users {
        _id
        role
        email
        firstName
        lastName
        avatarUrl
        isSeller
        paymentSetupComplete
      }
    }
  }
`;

export const GET_SINGLE_USER = gql`
  query me {
    me {
      _id
      firstName
      lastName
      email
      avatarUrl
      role
      isSeller
      paymentSetupComplete
      totalLikes
      likedBy
      createdAt
    }
  }
`;
